import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { InicialComponent } from './inicial/inicial.component';
import {ComponentesModule} from "../../core/componentes/componentes.module";


@NgModule({
  declarations: [
    InicialComponent
  ],
    imports: [
        CommonModule,
        HomeRoutingModule,
        ComponentesModule
    ]
})
export class HomeModule { }
